import React from 'react'

import './RestoreWallet.css'
import TitleHolder from '../shared/TitleHolder/TitleHolder'
import QbHeading from '../shared/QbHeading/QbHeading'
import QbInput from '../shared/QbInput/QbInput'
import QbLink from '../shared/QbLink/QbLink'
import QbButton from '../shared/QbButton/QbButton'
import { CREATE_WALLET_NAV } from '../../constants/navigation'
import QbQrScanner from "../shared/QbQrScanner/QbQrScanner"
import { TermsBox } from '../Terms/Terms'

const RestoreWallet = ({
  t,
  restoreProfile,
  onPasswordChange,
  onRepeatPasswordChange,
  onMnemonicChange,
  onSecureRestoredWallet,
  showSecure,
  showQrReader,
  onRestoreWithMnemonic,
  handleShowQrReader,
  handleScanError,
  handleScan,  
  errorMessages,
  wallet,
  checkboxError,
  checkboxSelected,
  onCheckboxClick,
}) => (
  <div className="main-content-container">
    <TitleHolder title={t('wallet.restore.title')} />
    <div className="main-content-body">

      {
        showSecure ? 
        <QbHeading
          title={t('wallet.restore.secure-headline')}
          text={t('wallet.restore.secure-message')}
        /> :
        <QbHeading
          title={t('wallet.restore.headline')}
          text={t('wallet.restore.message')}
          warning={wallet.address ? t('wallet.restore.message-warning') : ''}
        />
      }
      
      { 
        showQrReader ?

          <div className="restore-wallet-content restore-wallet-qr-content">
            <QbQrScanner
              title={t('wallet.restore.provide-mnemonic-label-qr')}
              onScan={handleScan}
              onError={handleScanError}
              errorMessage={t(errorMessages.mnemonic)}
            />
            <QbButton simple name={t('button-actions.cancel')} onClick={handleShowQrReader} style={{fontWeight: 'normal', color: 'var(--qb-gray-color)'}}/>
          </div> 

          :

          <div className={`restore-wallet-content ${getContentClass(showSecure)}`}>
            {
              showSecure ?
                <React.Fragment>
                  <QbInput
                    type="password"
                    value={restoreProfile.password}
                    title={t('wallet.create.type-password-label')}
                    onChange={onPasswordChange}
                    errorMessage={t(errorMessages.password)}
                  />

                  <QbInput
                    type="password"
                    value={restoreProfile.repeatPassword}
                    title={t('wallet.create.retype-password-label')}
                    onChange={onRepeatPasswordChange}
                    errorMessage={t(errorMessages.repeatPassword)}
                  />

                  <TermsBox
                    checkboxSelected={checkboxSelected}
                    onCheckboxClick={onCheckboxClick}
                    checkboxError={checkboxError}
                  />
                </React.Fragment>
                :
                <QbInput
                  type="text"
                  value={restoreProfile.mnemonic}
                  title={t('wallet.restore.provide-mnemonic-label')}
                  onChange={onMnemonicChange}
                  handleShowQrReader={handleShowQrReader}
                  textarea
                  errorMessage={t(errorMessages.mnemonic)}
                  qrButton
                />
            }

            <div className="main-content-footer">
              <QbLink regular name={t('button-actions.cancel')} to={CREATE_WALLET_NAV}/>
              {
                showSecure ?
                  <QbButton
                  name={t('button-actions.secure-wallet')}
                    onClick={() => onSecureRestoredWallet(restoreProfile.mnemonic, restoreProfile.password)}/>
                  :
                  <QbButton
                    name={t('button-actions.restore-wallet')}
                    onClick={onRestoreWithMnemonic}
                  />
              }
            </div>

          </div>
        }
    </div>
  </div>
)

export default RestoreWallet

const getContentClass = showSecure => !showSecure ? 'restore-wallet-content--mnemonic' : ''



// WEBPACK FOOTER //
// ./src/components/RestoreWallet/RestoreWallet.js